import { AssetParameter } from '../../types/interfaces';
import { AssetParameterWithMeasuresModel } from '../../types/interfaces/AssetParameterWithMeasuresModel';
import { ObjectForSelection } from '../../types/interfaces/ObjectForSelection';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IAssetParametersService from './interfaces/AssetParametersService';
import ServiceResult from './interfaces/ServiceResult';

class AssetParametersService
  extends BaseService<AssetParameter>
  implements IAssetParametersService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'AssetParameters');
  }

  getWithMeasures(
    id: number | undefined
  ): ServiceResult<AssetParameterWithMeasuresModel> {
    const apiCalls = this._apiCalls.beginApiCalls();
    if (!id) {
      return {
        result: apiCalls.AssetParameters.getMeasures().then((x) => ({
          assetParameter: undefined,
          measures: x
        })),
        cancel: apiCalls.cancelAllCalls
      };
    }
    const resultPromise = Promise.all([
      apiCalls.AssetParameters.get(id),
      apiCalls.AssetParameters.getMeasures()
    ]).then(
      ([assetParameter, measures]): AssetParameterWithMeasuresModel => ({
        assetParameter,
        measures
      })
    );
    return { result: resultPromise, cancel: apiCalls.cancelAllCalls };
  }

  getByAssetType(id: number): ServiceResult<AssetParameter[]> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.AssetParameters.getByAssetType(id),
      cancel: apiCalls.cancelAllCalls
    };
  }

  getForSelection(): ServiceResult<ObjectForSelection[] | undefined> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.AssetParameters.getForSelection(),
      cancel: apiCalls.cancelAllCalls
    };
  }
}

export default AssetParametersService;
